(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/image-helpers/assets/javascripts/image-provider.js') >= 0) return;  svs.modules.push('/components/onboarding/image-helpers/assets/javascripts/image-provider.js');
"use strict";

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useRef,
  useMemo,
  useEffect,
  useCallback,
  useState,
  forwardRef
} = React;
const {
  ImageContext
} = svs.components.onboarding.imageHelpers;

const createImage = src => forwardRef((props, ref) => {
  const imgProps = _objectSpread(_objectSpread({}, props), {}, {
    src
  });
  return React.createElement("img", _extends({}, imgProps, {
    ref: ref
  }));
});
const createLazyImage = (src, loadedPromise) => forwardRef((props, ref) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  if (!imageLoaded) {
    loadedPromise
    .then(() => {
      setImageLoaded(true);
    })
    .catch(() => {
    });
    return null;
  }
  const imgProps = _objectSpread(_objectSpread({}, props), {}, {
    src
  });
  const Img = createImage(src);
  return React.createElement(Img, _extends({}, imgProps, {
    ref: ref
  }));
});
const createSignal = () => {
  let trigger;
  const p = new Promise(resolve => {
    trigger = () => {
      resolve();
    };
  });
  return [p, trigger];
};
const ImageProvider = _ref => {
  let {
    children
  } = _ref;
  const imageQueue = useRef(new Map());
  const loadImageIntoRef = useCallback(src => {
    if (!imageQueue.current.has(src)) {
      const [loadedPromise, triggerLoaded] = createSignal();
      imageQueue.current.set(src, {
        src,
        loadedPromise,
        triggerLoaded
      });
    }
    return imageQueue.current.get(src).loadedPromise;
  }, []);
  const state = useMemo(() => ({
    useLazyImage: (src, shouldOptOut) => shouldOptOut ? createImage(src) : createLazyImage(src, loadImageIntoRef(src))
  }), [loadImageIntoRef]);
  useEffect(() => {
    const requestId = window.requestIdleCallback(() => {
      const loadImage = src => new Promise(resolve => {
        const image = new Image();
        image.onload = () => {
          resolve(image);
        };
        image.src = src;
      });
      const workImageQueue = async imageIterator => {
        const imageEntry = imageIterator.next();
        if (!imageEntry.done) {
          const {
            src,
            triggerLoaded
          } = imageEntry.value[1];
          await loadImage(src);
          triggerLoaded();
          workImageQueue(imageIterator);
        } else if (imageQueue.current.size > 0) {
          const _imageQueue = new Map(imageQueue.current);
          imageQueue.current = new Map();
          workImageQueue(_imageQueue.entries());
        }
      };
      const processQueue = () => {
        const _imageQueue = new Map(imageQueue.current);
        imageQueue.current = new Map();
        workImageQueue(_imageQueue.entries());
      };
      processQueue();
    });
    return () => {
      window.cancelIdleCallback(requestId);
    };
  }, []);
  return React.createElement(ImageContext.Provider, {
    value: state
  }, children);
};
setGlobal('svs.components.onboarding.imageHelpers.ImageProvider', ImageProvider);

 })(window);